import { Link } from 'react-router-dom';
import { CatalogItem } from './CatalogItem';
import '../styles/content.css';

/**
 * Renders the prose blocks stored in src/data/*.json. The same shapes are
 * rendered as static HTML by scripts/prerender.mjs, so a change here needs the
 * matching change there — otherwise Google's first crawl and the rendered page
 * would disagree.
 */
export const ContentSections = ({ sections = [], products = [] }) => (
  <>
    {sections.map((section, i) => (
      <section key={i} className="content-section">
        {section.h2 && <h2>{section.h2}</h2>}
        {section.p?.map((text, j) => <p key={j}>{text}</p>)}
        {section.ol && (
          <ol>{section.ol.map((item, j) => <li key={j}>{item}</li>)}</ol>
        )}
        {section.ul && (
          <ul>{section.ul.map((item, j) => <li key={j}>{item}</li>)}</ul>
        )}
        {section.after?.map((text, j) => <p key={j}>{text}</p>)}
        {section.products && <ProductCards ids={section.products} products={products} />}
        {section.links && (
          <ul className="content-links">
            {section.links.map(link => (
              <li key={link.href}><Link to={link.href}>{link.text}</Link></li>
            ))}
          </ul>
        )}
      </section>
    ))}
  </>
);

/** Картите от каталога по id от Firestore; изтрит продукт просто не се показва. */
export const ProductCards = ({ ids = [], products = [], label }) => {
  const shown = ids.map(id => products.find(p => p.id === id)).filter(Boolean);
  if (!shown.length) return null;
  return (
    <>
      {label && <p className="content-products-label">{label}</p>}
      <div className="content-products">
        {shown.map(p => <CatalogItem key={p.id} {...p} />)}
      </div>
    </>
  );
};

export const Faq = ({ items = [], heading = 'Често задавани въпроси' }) => {
  if (!items.length) return null;
  return (
    <section className="content-section content-faq">
      <h2>{heading}</h2>
      {items.map((item, i) => (
        <div key={i} className="content-faq-item">
          <h3>{item.q}</h3>
          <p>{item.a}</p>
        </div>
      ))}
    </section>
  );
};
